import { Dispatch } from 'redux';
import { IOptions } from 'src/utils/Transfers';

import * as Actions from '../actions/quickModeContens';
import AbstractScenario from './AbstractScenario';

export interface IContentsTextInfo {
	fileName: string;
	filePath: string;
	resourceFolder: string;
}

export interface ICourseInfo {
	courseFolder: string;
	courseName: string;
	orgId: string;
	textList: IContentsTextInfo[];
	testModel: Actions.ITestInfo | null;
}

export default class QuickModeScenarioFactory {
	/**
	 * courseFolder取得
	 * @param dispatch
	 * @param token
	 */
	public static createFetchCourseFolder(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process() {
				const param = {
					accessType: '10',
				};
				return this.read('per_quickMode_courseInit', param).then(
					data => {
						const courseFolder = data.courseFolder;
						const fileSize = data.fileSize;
						dispatch(
							Actions.setCourseFolder({ courseFolder, fileSize })
						);
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}

	public static createExportCourse(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<ICourseInfo> {
			protected process(arg: ICourseInfo) {
				const param: IOptions = {
					accessType: '10',
					courseFolder: arg.courseFolder,
					courseName: arg.courseName,
					orgId: arg.orgId,
				};
				if (arg.textList) {
					param.textList = arg.textList.map(
						(item: IContentsTextInfo) => ({
							fileName: item.fileName,
							filePath: item.filePath,
							resourceFolder: item.resourceFolder,
						})
					);
				}
				if (arg.testModel) {
					param.testModel = {
						numberOfQuestions: arg.testModel.numberOfQuestions,
						oneQuestionOneAnswer:
							arg.testModel.isOneQuestionOneAnswer,
						passScore: arg.testModel.passScore,
					};
					if (arg.testModel.questions.length > 0) {
						param.testModel.questionList = arg.testModel.questions.map(
							(item: Actions.IQuestionInfo) => ({
								explanation: item.explanation,
								options: item.options.map(opt => ({
									answer: opt.answer,
									answerText: opt.answerText,
								})),
								questionKind: item.questionKind,
								questionScore: item.questionScore,
								questionText: item.questionText,
								seq: item.seq,
							})
						);
					}
				}
				return this.read('per_quickMode_exportCourse', param);
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/QuickModeContentsScenarioFactory.ts